//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import moment from 'moment'

export default {
    layout: 'default',

    data(){ return {
        showParallaxHeader: false,

        videos: [],
        series: [],
        episodes: [],
        scrolled: false,
        visible: {
            videos: false,
            episodes: false,
            series: false,
        }
    }},

    metaInfo(){ return {
        title: 'YouTube Manager',
        link: [
            { rel: 'canonical', href: window.location.href }
        ],
        meta: this.$rm.getMeta(this), //this.$route.meta
    }},

    filters: {
        getDate(val){
            return moment(val).format('DD.MM.YYYY')
        }
    },

    mounted(){
        // this.sound()
        // this.load()
    },

    beforeRouteEnter(to, from, next){
            axios.get('/api/ytm/v1/videos/latest')
                 .then( r =>  {
                      next( vm => {
                          vm.videos = r.data.videos
                          vm.series = r.data.series
                          vm.episodes = r.data.episodes
                      })
                  })
                 .catch( e => {
                      console.log(e)
                      next(vm => {
                          vm.loadingError = true
                      })
                 })
    },

    methods: {
        sound(){
            let audio = new Audio(require('~/assets/netflix.wav'))
            audio.play()
        },

        load(){
            axios.get('/api/ytm/v1/videos/latest')
                 .then( r => {
                      this.videos = r.data.videos
                 })
                 .catch( e => console.log(e) )
        },

        scroll(s){
            if(this.scrolled) return;

            if(s > 100){
                this.scrolled = true
                // this.load()
            }
        },

        playVideo(item){
            let series = [item]
            let episode = this.$ytm.getLatestVideoFromSeries(series)
            let id = this.$ytm.getId(episode)

            this.play(id)
        },

        play(id){
            if(id)
              this.$router.push({ name: 'player', params: { id } })
            else
              console.log('Error in Series: ', item)
        },

        loadingError(a,b){
            // console.log('loading error', a, b)
        },

        loadedImage(item){
            // console.log('loaded image', item)
        },

        intersect(i, type){
            if(i.isIntersecting)
              this.visible[type] = true
        }

    }
}
